import type { ReactElement } from "react";

import { extractSource } from "@rootreeweb/js-lib";

type WallpaperProps = {
	desktop_link: string;
	language: "EN" | "FR";
	mobile_link: string;
	thumbnail: string;
};

/**
 * Display a wallpaper.
 *
 * @param props The properties for the component.
 * @returns The wallpaper listing.
 */
export function Wallpaper(props: WallpaperProps): ReactElement {
	const { desktop_link, language, mobile_link, thumbnail } = props;
	return (
		<div>
			<div>
				<img alt="" height="300" src={extractSource(thumbnail)} width="300" />
			</div>
			<div className="hl:flex hl:flex-col hl:justify-center hl:gap-4 hl:first:mb-8 hl:lg:flex-row">
				<a
					className={"hl:text-white"}
					download
					href={desktop_link}
					target="_blank"
				>
					{language === "FR" ? "Pour bureau d'ordinateur" : "Desktop"}
				</a>
				<a
					className={"hl:text-white"}
					download
					href={mobile_link}
					target="_blank"
				>
					{language === "FR" ? "Pour téléphone portable" : "Mobile"}
				</a>
			</div>
		</div>
	);
}
